import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useParams } from 'react-router-dom';
import { formatParagraphs, getImageFilepath } from '../../../models/Utils';
import Button from '../../Common/Button/Button';
import { setExploreClicked } from '../../../store/reducers/mainReducer';
import './Story.scss';
import { useWindowSize } from '../../../models/Hooks';
import { ADAARIARoles } from '../../../models/ADA';

const Story = ({ homeData, isInline, topOffset }) => {
  const dispatch = useDispatch();
  const window = useWindowSize();
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const status = useSelector(state => state.data.exploreClicked);
  const menuOpened = useSelector(state => state.data.menuOpened);
  let { storyId } = useParams();
  const [animate, setAnimate] = useState(true);
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  useEffect(() => {
    setAnimate(true);
    setTimeout(() => setAnimate(false), 1000);
  }, [storyId]);

  const ExploreClicked = () => {
    dispatch(setExploreClicked(true));
  };

  var outerClassname = `story-component home__story-section ${status ? 'active' : 'inactive'} ${
    homeData.lightBg ? '' : 'darkBg'} ${isInline ? 'inline' : ''}`;
  var containerClassname = 'row home__story-row';
  var backgoundClassname = 'background';
  var cardHolderClassname = isPortrait ? 'card-holder portrait' : 'card-holder landscape';
  var exploreClassname = isPortrait ? 'explore-more portrait' : 'explore-more landscape';
  if (status) {
    containerClassname += ' active';
    backgoundClassname += ' active';
    cardHolderClassname += ' active';
    exploreClassname += ' active';
  } else {
    containerClassname += ' inactive';
    backgoundClassname += ' inactive';
    cardHolderClassname += ' inactive';
    exploreClassname += ' inactive';
  }

  return (
    <div className={outerClassname} tabIndex="-1" style={{top: -topOffset+"px"}}>
      <div className={backgoundClassname} />
      <div className={`container ${animate ? 'animate' : ''}`}>
        <div
          className="row home__story-row"
          style={{
            display: 'flex',
            flexDirection: homeData.imgStart === 'start' ? 'row-reverse' : 'row',
          }}
        >
          <div className="home__story-text-wrapper">
            <h1 className="top-line" role={ADAARIARoles.Heading}>{homeData.Header}</h1>
            {!status ? <div className="heading" >{homeData.Subheader}</div> : null}
            {!status ? (
              isPortrait ? (
                <>
                  <Button
                    buttonSize="btn--large"
                    buttonColor="transparent"
                    onClick={ExploreClicked}
                  >
                    {homeData.ButtonLabel ? homeData.ButtonLabel : 'Explore'}
                  </Button>
                </>
              ) : null
            ) : (
              <>
                <div className="body">{formatParagraphs(homeData.Body)}</div>
              </>
            )}
          </div>
        </div>
        {!status && (
          <div className={cardHolderClassname}>
            <div className="thumb-container">
              {homeData.Thumbnails.map((e, i) => (
                <img
                  key={e.Key}
                  className="thumb"
                  style={{ zIndex: homeData.Thumbnails.length - i }}
                  src={mediaPath + getImageFilepath(e.Thumbnail.Image, window.height * 0.3)}
                  alt={e.Thumbnail.AltText}
                />
              ))}
            </div>
            {isPortrait === false ? (
              <div className="button-holder">
                <Button buttonSize="btn--large" buttonColor="transparent" onClick={ExploreClicked}>
                  {homeData.buttonLabel ? homeData.buttonLabel : 'Explore'}
                </Button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Story;
